
// 金融行业
export const FINANCE_INDUSTRY = new Set(['011019001', '011019002', '011019003', '011018001']);

